
if (!customElements.get('email-popup')) {
  customElements.define('email-popup', class EmailPopup extends HTMLElement {
    constructor() {
      super();

      if (window.location.pathname === "/challenge") return;

      this.popup = this.querySelector(".email__popup--mdoal__content");
      if (!this.popup) return;

      this.closePopup = this.querySelectorAll(
        ".email__popup--toggle, .email-popup-overlay"
      );
      this.hidePopup = this.querySelector(".email__popup--hide");

      this.cookieName = "email-popup";
      this.countKey = "email-popup-appearance-count";
      this.maxAppearances = 2;
      this.timer = null;
      this.isOpen = false;

      this.closePopup.forEach((item) => {
        item.addEventListener("click", () => this.close());
      });

      this.hidePopup?.addEventListener("click", () => this.hide());

      if (this.dataset.mode === "test") {
        this.init();
      } else if (
        !this.getCookie(this.cookieName) &&
        this.getCount() < this.maxAppearances
      ) {
        this.init();
      }

      if (window.Shopify?.designMode) {
        document.addEventListener("shopify:section:select", () => this.open(true));
        document.addEventListener("shopify:section:deselect", () => this.close());
      }
    }

    getCount() {
      try {
        return Number(localStorage.getItem(this.countKey)) || 0;
      } catch (e) {
        return 0;
      }
    }

    setCount(count) {
      try {
        localStorage.setItem(this.countKey, String(count));
      } catch (e) {
        // Storage may be unavailable in private browsing.
      }
    }

    init() {
      if (window.Shopify?.designMode) return;

      const delay = Math.max(0, Number(this.dataset.delay) || 5);

      this.timer = setTimeout(() => {
        this.open();
      }, delay * 1000);
    }

    open(force = false) {
      if (!this.popup || this.isOpen) return;

      const isTesting = this.dataset.mode === "test";

      if (
        !force &&
        !isTesting &&
        (this.getCookie(this.cookieName) ||
          this.getCount() >= this.maxAppearances)
      ) {
        return;
      }

      this.isOpen = true;

      document.body.classList.add("email-popup-show");
      this.popup.classList.remove("popup-closing");
      this.popup.classList.add("popup-open");

      // Count each actual appearance, not every page visit.
      if (!force && !isTesting) {
        this.setCount(this.getCount() + 1);
      }
    }

    close() {
      if (!this.popup || !this.isOpen) return;

      this.isOpen = false;
      document.body.classList.remove("email-popup-show");
      this.popup.classList.add("popup-closing");

      setTimeout(() => {
        this.popup.classList.remove("popup-open", "popup-closing");
      }, 500);
    }

    hide() {
      this.close();

      if (this.dataset.mode !== "test") {
        const expiry = Number(this.dataset.expire) || 7;
        this.setCookie(this.cookieName, expiry);
        this.setCount(this.maxAppearances);
      }
    }

    getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")
      );
      return match ? match[2] : null;
    }

    setCookie(name, expiry) {
      document.cookie =
        `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/; SameSite=Lax`;
    }

    removeCookie(name) {
      document.cookie = `${name}=; max-age=0; path=/`;
    }
  });
}
